import { useEffect } from 'react';
import { usePageLoadStatus } from 'src/hooks/usePageLoadStatus';
import { useUserHasAnyOfPermissions } from 'src/hooks/useUserHasAnyOfPermissions';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import {
  ALL_INVENTORY_VIEW_PERMISSIONS,
  ALL_SALES_VIEW_PERMISSIONS,
} from 'src/utils/userUtils';
import { Feature, Permission } from 'src/WebApiController';

import { Dashboard } from '../Dashboard';

export function Home() {
  const { registerComponent } = usePageLoadStatus();

  // Determine which components will be rendered based on permissions and feature flags
  const hasHomePageActivityLogFeature = useUserHasFeature(
    Feature.HomePageActivityLog
  );
  const hasViewSalesPermission = useUserHasAnyOfPermissions(
    ...ALL_SALES_VIEW_PERMISSIONS
  );
  const hasViewListingsPermission = useUserHasAnyOfPermissions(
    ...ALL_INVENTORY_VIEW_PERMISSIONS
  );
  const hasViewSalesDataPermission = useUserHasAnyOfPermissions(
    Permission.Sales_ViewHomePageMetrics
  );

  useEffect(() => {
    // Register all components that might be rendered
    registerComponent('LayoutContent');

    if (hasViewListingsPermission) {
      registerComponent('MetricsSection');
    }

    if (hasViewSalesDataPermission) {
      registerComponent('DataInsightsChartSection');
    }

    if (hasViewSalesPermission) {
      registerComponent('RecentSalesSection');
    }

    if (hasHomePageActivityLogFeature) {
      registerComponent('ActivitySection');
    }
  }, [
    registerComponent,
    hasViewListingsPermission,
    hasViewSalesDataPermission,
    hasViewSalesPermission,
    hasHomePageActivityLogFeature,
  ]);

  return <Dashboard />;
}
